/**
 * Símbolo oficial de n8n (T11 · decisión A del paquete).
 *
 * PROCEDENCIA, porque una marca ajena no se dibuja de memoria. El trazo de abajo se leyó
 * literal del lockup que la propia n8n sirve en `https://n8n.io` (SVG inline de 87×24, dos
 * trazos: `path-icon` = el símbolo de nodos, `path-name` = el wordmark «n8n»). Aquí va SOLO
 * `path-icon`, con su geometría intacta: ni redibujado, ni redondeado, ni recompuesto.
 *
 * POR QUÉ SOLO EL SÍMBOLO: el Spec §7 [A2] ya documentó que el wordmark blanco del lockup
 * desaparece sobre tema claro, y por eso David recortó en su día un PNG sin él. El símbolo
 * monocromo hereda `currentColor` y funciona en los dos temas y sobre cualquier superficie,
 * que es justo lo que el Spec dejaba pendiente («versión monocromática/SVG que herede
 * currentColor»).
 *
 * VIEWBOX RECORTADO AL TRAZO, no al lienzo del lockup: el símbolo ocupa x ∈ [1.1855, 47.9855]
 * e y ∈ [0, 24] del original. Conservar `0 0 87 24` dejaría 39px de aire a la derecha (el
 * hueco del wordmark) y el símbolo se pintaría a mitad de tamaño y descentrado dentro de su
 * caja. Se recorta el lienzo, NO el dibujo.
 *
 * LICENCIA / USO: la marca es de n8n GmbH. Se usa aquí de forma nominativa —identificar al
 * grupo «n8n Chile» dentro de la Comunidad Umbral—, monocroma y sin alterar su geometría.
 * El permiso de uso lo confirma David en el paquete PKG-N8N-CL-FLARUM-T11-REMAINING
 * (decisión A: «SVG o PNG oficial n8n, licencia/uso OK»). Esto CIERRA el pendiente [A2] del
 * Spec §7.
 *
 * --- TRES COPIAS DEL TRAZO, Y NI UNA MÁS ---
 *
 * Este módulo es la fuente para todo lo que pinta la SPA (D7 y la n8card). Las otras dos
 * existen porque no pueden importar TypeScript:
 *
 *   1. `docs/operations/assets/2026-08-04-flarum-t02-theme/cm-home.html` — la puerta B de la
 *      landing, que se sirve como `custom_header` y vive fuera del bundle.
 *   2. `resources/views/partials/n8n-mark.blade.php` — el lado servidor. Es un PARCIAL, no una
 *      copia por vista: cualquier Blade que necesite la marca lo incluye.
 *
 * Si el trazo cambia aquí, hay que cambiarlo en las dos. `t11.spec.ts` compara el de la landing
 * y el de la SPA, y comprueba que el HTML server-side de D7 también lo trae.
 */
export const N8N_MARK_VIEWBOX = '1.18 0 46.81 24';

export const N8N_MARK_PATH =
  'M47.9855 4.8C47.9855 7.45098 45.8365 9.6 43.1855 9.6C40.949 9.6 39.0696 8.0703 38.5368 6H31.8352C30.662 6 29.6607 ' +
  '6.84822 29.4678 8.00544L29.2706 9.18912C29.0832 10.313 28.5147 11.2911 27.7108 12C28.5147 12.7089 29.0832 13.687 ' +
  '29.2706 14.8109L29.4678 15.9946C29.6607 17.1518 30.662 18 31.8352 18H33.7368C34.2696 15.9297 36.149 14.4 38.3855 ' +
  '14.4C41.0365 14.4 43.1855 16.549 43.1855 19.2C43.1855 21.851 41.0365 24 38.3855 24C36.149 24 34.2696 22.4703 ' +
  '33.7368 20.4H31.8352C29.4888 20.4 27.4863 18.7036 27.1005 16.3891L26.9032 15.2054C26.7104 14.0482 25.7091 13.2 ' +
  '24.5359 13.2H22.5782C21.979 15.1681 20.1495 16.6 17.9855 16.6C15.8216 16.6 13.9921 15.1681 13.3929 13.2H10.5782C' +
  '9.97901 15.1681 8.14949 16.6 5.98554 16.6C3.33458 16.6 1.18555 14.4509 1.18555 11.8C1.18555 9.14904 3.33458 ' +
  '7.00002 5.98554 7.00002C8.29361 7.00002 10.2212 8.62902 10.6812 10.8H13.2899C13.7499 8.62902 15.6775 7.00002 ' +
  '17.9855 7.00002C20.2936 7.00002 22.2212 8.62902 22.6812 10.8H24.5359C25.7091 10.8 26.7104 9.95178 26.9032 ' +
  '8.79456L27.1005 7.61088C27.4863 5.29638 29.4888 3.6 31.8352 3.6H38.5368C39.0696 1.52973 40.949 0 43.1855 0C' +
  '45.8365 0 47.9855 2.14903 47.9855 4.8ZM45.5855 4.8C45.5855 6.12546 44.511 7.2 43.1855 7.2C41.8601 7.2 40.7855 ' +
  '6.12546 40.7855 4.8C40.7855 3.47452 41.8601 2.4 43.1855 2.4C44.511 2.4 45.5855 3.47452 45.5855 4.8ZM5.98554 ' +
  '14.2C7.31105 14.2 8.38553 13.1255 8.38553 11.8C8.38553 10.4745 7.31105 9.40002 5.98554 9.40002C4.66006 9.40002 ' +
  '3.58554 10.4745 3.58554 11.8C3.58554 13.1255 4.66006 14.2 5.98554 14.2ZM17.9855 14.2C19.311 14.2 20.3855 ' +
  '13.1255 20.3855 11.8C20.3855 10.4745 19.311 9.40002 17.9855 9.40002C16.6601 9.40002 15.5855 10.4745 15.5855 ' +
  '11.8C15.5855 13.1255 16.6601 14.2 17.9855 14.2ZM38.3855 21.6C39.711 21.6 40.7855 20.5255 40.7855 19.2C40.7855 ' +
  '17.8745 39.711 16.8 38.3855 16.8C37.0601 16.8 35.9855 17.8745 35.9855 19.2C35.9855 20.5255 37.0601 21.6 38.3855 ' +
  '21.6Z';

/**
 * El símbolo como vnode.
 *
 * `aria-hidden` porque nunca va solo: en las tres superficies (puerta B, D7, n8card) el texto
 * «n8n Chile» está al lado, y un lector de pantalla que anunciara además «logo de n8n» diría
 * la misma cosa dos veces.
 */
export default function n8nMark(className = 'cm-n8n-mark') {
  return (
    <svg className={className} viewBox={N8N_MARK_VIEWBOX} fill="currentColor" aria-hidden="true" focusable="false">
      <path fill-rule="evenodd" clip-rule="evenodd" d={N8N_MARK_PATH} />
    </svg>
  );
}
